import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled, { css } from 'styled-components';
import { minMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';
var headingStyles = function headingStyles(index) {
  return css(["display:inline-block;", ";font-weight:700;", ";"], getFont(index, 'compact'), function (_ref) {
    var center = _ref.center;
    return center ? 'text-align: center;' : null;
  });
};
export var H1 = styled.h1.withConfig({
  displayName: "Headings__H1",
  componentId: "sc-1ap3edt-0"
})(["", ";", ";&:not(:last-child){", ";}"], function (_ref2) {
  var large = _ref2.large;
  return large ? headingStyles(4) : headingStyles(3);
}, minMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n  "])), function (_ref3) {
  var large = _ref3.large;
  return large ? headingStyles(5) : headingStyles(4);
}), function (_ref4) {
  var noPadding = _ref4.noPadding;
  return !noPadding && 'padding-bottom: 24px;';
});
export var H2 = styled.h2.withConfig({
  displayName: "Headings__H2",
  componentId: "sc-1ap3edt-1"
})(["", ";", ";&:not(:last-child){", ";}"], headingStyles(3), minMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n  "])), headingStyles(4)), function (_ref5) {
  var noPadding = _ref5.noPadding;
  return !noPadding && 'padding-bottom: 18px;';
});
export var H3 = styled.h3.withConfig({
  displayName: "Headings__H3",
  componentId: "sc-1ap3edt-2"
})(["", ";", ";&:not(:last-child){", ";}"], headingStyles(2), minMediaQueries.phablet(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n  "])), headingStyles(3)), function (_ref6) {
  var noPadding = _ref6.noPadding;
  return !noPadding && 'padding-bottom: 12px;';
});
export var H4 = styled.h4.withConfig({
  displayName: "Headings__H4",
  componentId: "sc-1ap3edt-3"
})(["", ";", ";&:not(:last-child){", ";}"], headingStyles(1), minMediaQueries.phablet(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n  "])), headingStyles(2)), function (_ref7) {
  var noPadding = _ref7.noPadding;
  return !noPadding && 'padding-bottom: 12px;';
});
export var H5 = styled.h5.withConfig({
  displayName: "Headings__H5",
  componentId: "sc-1ap3edt-4"
})(["", ";&:not(:last-child){", ";}"], headingStyles(1), function (_ref8) {
  var noPadding = _ref8.noPadding;
  return !noPadding && 'padding-bottom: 12px;';
});
export var H6 = styled.h6.withConfig({
  displayName: "Headings__H6",
  componentId: "sc-1ap3edt-5"
})(["", ";&:not(:last-child){", ";}"], headingStyles(0), function (_ref9) {
  var noPadding = _ref9.noPadding;
  return !noPadding && 'padding-bottom: 12px;';
});